<template lang="pug">
div.Case-list-content
  div.title 我的案例
  div.list-region
    ul.case-area
      li.add-to(@click="add_case",v-if="pageData.pageNo === 1")
        img(src='../../../assets/Student/case_list/addCase.png')
        span 添加案例
      li.list(v-for='v in caseList')
        div.chart
          img(:src='v.caseCover')
        div.hover
          div.icon
            div.create(@click='gotoCase(v)')
              Icon(type="md-create")
            div.trash(@click='delCase(v)')
              Icon(type="md-trash")
        div.list-tag
          p.label {{v.caseName}}
        div.type-nav
          p.label-2(v-for='(x,idx) in v.caseTypes',v-if='idx<=2') {{x}}
        div.list-tag-2
          span.left {{v.turnoverTime}}
          span.right • {{v.auditStatus}}
    Page.page(@on-change="handleCurrentChange" :total="pageData.totalRecords%10 === 0 ? pageData.totalRecords+1 : pageData.totalRecords",
          :page-size="10" :current="pageData.pageNo" show-elevator show-total)
          span 当前有{{caseList.length}}条数据，共{{pageData.totalRecords}}条数据
          .cp
</template>
<script>
export default {
  data() {
    return {
      list: [],
      caseList: [],
      pageData: {}
    };
  },
  created() {
    this.query();
  },
  methods: {
    handleCurrentChange(page) {
        this.query(page);
    },
    delCase(value) {
      this.$Modal.confirm({
        title: "删除",
        content: "<p>是否删除该案例?</p>",
        onOk: () => {
          this.$http.batchDeletingCaseExperiment({ ids: `[${value.id}]` }).then(res => {
            if (res.data.success) {
              this.$Message.success("删除成功!");
              this.query();
            } else {
              this.$Message.error("删除失败!");
            }
          });
        }
      });
    },
    add_case() {
      const item1 = {
        CaseBrief: "",
        title: "", // 自定义案例的标题
        type: [], // 自定义案例的类型
        file: "", // 上传的图片
        id: "", // 案例的Id
        src: "",
        stem: "" // 案例的分析内容
      };
      sessionStorage.removeItem("CaseStage");
      this.$store.commit("postCaseContent", item1);
      this.$store.commit("ResetCaseData");
      this.$router.push("/case");
    },
    gotoCase(v) {
      // 跳转案例页面
      // console.log(v);
      const item1 = {
        title: v.caseName,
        CaseBrief: v.caseDescription,
        type: v.caseTypes,
        file: "",
        src: v.caseCover,
        id: v.id,
        stem: v.editorOption
      };
      sessionStorage.removeItem("CaseStage");
      this.$store.commit("ResetCaseData");
      this.$store.commit("postCaseContent", item1);
      this.$router.push("/case");
    },
    query(page = 1) {
      const data = {
        pageNo: page,
        pageSize: page === 1 ? 9 : 10,
        userId: this.$role.code
      };
      this.$http.stuListCaseExperiment(data).then(res => {
        console.log(res.data);
        this.pageData = res.data.data;
        function formatDate(dateL) {
          const now = new Date(dateL);

          const month = now.getMonth() + 1;

          const date = now.getDate();

          const hour = now.getHours();

          const minute = now.getMinutes();

          return `${month}-${date} ${hour}:${minute}`;
        }
        this.caseList = res.data.data.list;
        this.caseList = this.caseList.map(res1 => {
          if (this.$role.role === "admin" || this.$role.role === "teacher") {
            return {
              caseCover: res1.caseCover,
              caseDescription: res1.caseDescription,
              caseName: res1.caseName,
              caseTypes: JSON.parse(res1.caseTypes),
              disable: res1.disable,
              editorOption: res1.editorOption,
              id: res1.id,
              turnoverTime: formatDate(Date.parse(new Date(res1.turnoverTime))),
              userId: res1.userId,
              userName: res1.userName
            };
          }
          return {
            auditStatus: res1.auditStatus,
            caseCover: res1.caseCover,
            caseDescription: res1.caseDescription,
            caseName: res1.caseName,
            caseTypes: JSON.parse(res1.caseTypes),
            disable: res1.disable,
              editorOption: res1.editorOption,
            id: res1.id,
            turnoverTime: formatDate(Date.parse(new Date(res1.turnoverTime))),
            userId: res1.userId,
            userName: res1.userName
          };
        });
      });
    }
  }
};
//     query() {
//       const data = {
//         userId: this.$role.code
//       };
//       this.$http.listCaseExperimentRequest(data).then(res => {
//         if (res.data.success) {
//           this.list = res.data.data.list;
//           this.list.forEach(res1 => {
//             const res2 = res1;
//             res2.caseTypes = JSON.parse(res1.caseTypes);
//           });
//         }
//       });
//     }
//   }
// };
</script>

<style lang="stylus" scoped>
.Case-list-content
  width 1128px
  margin 0 auto
  .page
    margin-top 42px
    text-align: right;
  .title
    text-align left
    font-size 24px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 1)
    margin-top 68px
  .list-region
    margin-top 48px
    .case-area
      display grid
      grid-template-columns 210px 210px 210px 210px 210px
      grid-column-gap 16px
      grid-row-gap 18px
      .add-to
        width 210px
        height 253px
        background #ffffff
        border-radius 4px
        cursor pointer
        img
          width 90px
          height 94px
          margin 40px auto 63px
          display block
        span
          font-size 12px
          font-family MicrosoftYaHeiUI
          color rgba(128, 128, 128, 1)
          text-align center
      .list
        width 210px
        height 253px
        background #fff
        vertical-align top
        border-radius 4px
        position relative
        &:hover
          .hover
            display block
        img
          width 100%
          height 118px
          margin 0 auto
          display block
        .hover
          position absolute
          top 0
          width 100%
          background rgba(0, 0, 0, 0.5)
          height 118px
          margin 0 auto
          display none
          .icon
            position absolute
            width 60%
            height 100%
            left 0
            right 0
            top 0
            bottom 0
            margin auto
            text-align center
          .create
            color #fff
            width 48px
            height 48px
            line-height 48px
            border-radius 8px
            background #000
            opacity 0.5
            top 36px
            text-align center
            font-size 18px
            cursor pointer
            position absolute
          .trash
            color #fff
            cursor pointer
            width 48px
            height 48px
            line-height 48px
            position absolute
            right 0
            border-radius 8px
            background #000
            opacity 0.5
            top 36px
            text-align center
            font-size 18px
          .ivu-icon
            color #fff
            font-size 22px
        .list-tag
          .label
            font-size 14px
            font-family MicrosoftYaHeiUI
            color rgba(42, 46, 54, 1)
            margin 8px 12px
            min-height 42px
            text-align left
            display -webkit-box
            -webkit-box-orient vertical
            -webkit-line-clamp 2
            overflow hidden
        .type-nav
          min-height 40px
          padding 0 8px
          text-align left
          .label-2
            display inline-block
            width 60px
            height 22px
            text-align center
            background rgba(60, 118, 208, 0.1)
            border-radius 2px
            margin-left 4px
            margin-bottom 4px
            font-size 12px
            font-family MicrosoftYaHeiUI
            color #3885E1
        .list-tag-2
          width 186px
          height 36px
          line-height 36px
          margin 0 12px
          border-top 1px solid #eee
          .left
            float left
            font-size 12px
            color rgba(42, 46, 54, 0.75)
          .right
            float right
            font-size 12px
            color rgba(128, 128, 128, 1)
</style>
